import { Card, CardContent, Typography } from '@mui/material'
import ReactECharts from 'echarts-for-react'

interface TopSourcesChartProps {
    sources: Array<{ source: string; visitors: number }>
}

export function TopSourcesChart({ sources }: TopSourcesChartProps) {
    const top = sources.slice(0, 8)

    const option = {
        tooltip: { trigger: 'axis' as const, axisPointer: { type: 'shadow' as const } },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'value' as const },
        yAxis: {
            type: 'category' as const,
            data: top.map(s => s.source || 'Direct'),
            inverse: true,
        },
        series: [
            {
                type: 'bar' as const,
                data: top.map(s => s.visitors),
                itemStyle: { color: '#6366f1', borderRadius: [0, 4, 4, 0] },
            },
        ],
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Top Sources
                </Typography>
                <ReactECharts option={option} style={{ height: 300 }} />
            </CardContent>
        </Card>
    )
}
